import { render, staticRenderFns } from "./NormalSearchNav65.vue?vue&type=template&id=6b1624fa&scoped=true&"
import script from "./NormalSearchNav65.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav65.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1624fa",
  null
  
)

export default component.exports